import { render, staticRenderFns } from "./leftMenu.vue?vue&type=template&id=b57a5c0a&scoped=true&"
import script from "./leftMenu.vue?vue&type=script&lang=js&"
export * from "./leftMenu.vue?vue&type=script&lang=js&"
import style0 from "./leftMenu.vue?vue&type=style&index=0&id=b57a5c0a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57a5c0a",
  null
  
)

export default component.exports